import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  margin: '20px 0',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  '& span': { color: theme.palette.secondary.main },
}));
